import React from 'react';

const IconAcclaim = () => (
  <svg xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 80 80">
    <title>YourAcclaim</title>
    <path
      d="
      M 55.12,21.37
      C 68.50,33.75 68.75,34.12 68.75,39.50
        68.75,42.75 68.12,45.00 67.38,45.00
        66.62,45.00 60.50,39.88 53.75,33.75
        47.00,27.50 41.00,22.50 40.50,22.50
        39.88,22.50 33.75,27.50 27.00,33.75
        20.12,39.88 14.12,45.00 13.50,45.00
        13.00,45.00 12.50,42.25 12.50,39.00
        12.50,39.00 12.50,33.00 12.50,33.00
        12.50,33.00 25.88,20.87 25.88,20.87
        33.38,14.25 39.88,8.75 40.50,8.75
        41.00,8.75 47.62,14.50 55.12,21.37 Z
      M 54.88,46.12
      C 67.75,58.12 67.88,58.38 68.00,64.12
        68.12,67.38 67.62,70.00 67.12,70.00
        66.50,70.00 60.50,65.00 53.88,58.75
        47.12,52.50 41.12,47.50 40.38,47.50
        39.75,47.50 33.62,52.50 26.75,58.75
        20.00,65.00 14.00,70.00 13.50,70.00
        12.88,70.00 12.50,67.38 12.50,64.00
        12.50,64.00 12.50,58.12 12.50,58.12
        12.50,58.12 25.88,45.88 25.88,45.88
        33.25,39.25 39.88,33.75 40.62,33.75
        41.25,33.88 47.75,39.38 54.88,46.12 Z"
    />
  </svg>
);

export default IconAcclaim;
